module.exports = __webpack_public_path__ + "img/defaultvideo.f9ed2d96.png";